@import "tailwindcss";
@import "./styles/tokens.css";

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'MiSans', 'Inter', system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  background-color: var(--color-background);
  color: var(--color-on-surface);
  line-height: 1.5;
}

#root {
  min-height: 100vh;
}

@keyframes fadeScaleIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes cardEnter {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-page-enter {
  animation: fadeScaleIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.animate-card-enter {
  animation: cardEnter 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.card-hover {
  transition: box-shadow 0.25s cubic-bezier(0.16, 1, 0.3, 1),
              border-color 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: box-shadow, border-color;
}

.card-hover:hover {
  box-shadow: 0 4px 12px var(--color-card-shadow-hover);
}
